import { api } from '../api/client.js';
import { clearToken } from '../api/session.js';
import { getState } from './views.js';
import { getVoiceSettings, setVoiceSettings, getComposeStyle, setComposeStyle, type ComposeStyle } from '../domain/voice-settings.js';
import { listActiveMemos } from '../storage/memosStore.js';

export function renderSettingsView(root: HTMLElement): () => void {
  const { user } = getState();
  const voice = getVoiceSettings();
  const composeStyle = getComposeStyle();

  root.innerHTML = `
    <div class="settings-view">
      <header class="settings-view__header"><h1>設定</h1></header>

      <section class="settings-view__section">
        <h2>アカウント</h2>
        <div class="settings-view__row">
          <span class="settings-view__label">メール</span>
          <span class="settings-view__value">${user.email}</span>
        </div>
        <div class="settings-view__row">
          <span class="settings-view__label">プラン</span>
          <span class="settings-view__value">Free</span>
        </div>
        <button type="button" class="settings-view__action settings-view__action--destructive" id="signout">サインアウト</button>
      </section>

      <section class="settings-view__section">
        <h2>音声</h2>
        <label class="settings-view__row">
          <span class="settings-view__label">音声モード</span>
          <input type="checkbox" id="voice-mode" ${voice.mode === 'auto' ? 'checked' : ''} />
        </label>
        <label class="settings-view__row">
          <span class="settings-view__label">沈黙タイムアウト</span>
          <select id="voice-silence">
            <option value="10000" ${voice.silenceTimeoutMs === 10000 ? 'selected' : ''}>10 秒</option>
            <option value="30000" ${voice.silenceTimeoutMs === 30000 ? 'selected' : ''}>30 秒</option>
            <option value="60000" ${voice.silenceTimeoutMs === 60000 ? 'selected' : ''}>60 秒</option>
          </select>
        </label>
      </section>

      <section class="settings-view__section">
        <h2>外観</h2>
        <label class="settings-view__row">
          <span class="settings-view__label">入力ボタン</span>
          <select id="compose-style">
            <option value="pill" ${composeStyle === 'pill' ? 'selected' : ''}>Pill (横長)</option>
            <option value="fab" ${composeStyle === 'fab' ? 'selected' : ''}>FAB (円形)</option>
          </select>
        </label>
      </section>

      <section class="settings-view__section">
        <h2>データ</h2>
        <button type="button" class="settings-view__action" id="export-json">📥 全データを JSON で保存</button>
      </section>

      <section class="settings-view__section">
        <h2>About</h2>
        <div class="settings-view__row">
          <span class="settings-view__label">バージョン</span>
          <span class="settings-view__value">v0.1.0</span>
        </div>
      </section>
    </div>
  `;

  root.querySelector('#signout')!.addEventListener('click', async () => {
    if (!confirm('サインアウトしますか?')) return;
    try { await api.signOut(); } catch {/* ignore */}
    clearToken();
    location.reload();
  });

  root.querySelector<HTMLInputElement>('#voice-mode')!.addEventListener('change', (e) => {
    setVoiceSettings({ mode: (e.target as HTMLInputElement).checked ? 'auto' : 'tap' });
  });
  root.querySelector<HTMLSelectElement>('#voice-silence')!.addEventListener('change', (e) => {
    setVoiceSettings({ silenceTimeoutMs: parseInt((e.target as HTMLSelectElement).value, 10) });
  });
  root.querySelector<HTMLSelectElement>('#compose-style')!.addEventListener('change', (e) => {
    setComposeStyle((e.target as HTMLSelectElement).value as ComposeStyle);
  });

  root.querySelector('#export-json')!.addEventListener('click', async () => {
    const memos = await listActiveMemos();
    const blob = new Blob([JSON.stringify(memos, null, 2)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `memori-export-${Date.now()}.json`;
    a.click();
    URL.revokeObjectURL(url);
  });

  return () => {};
}
